import { createSaveStateTracker } from '@/lib/save-state';

export const meetingSaves = createSaveStateTracker('meeting save');
